/**
 * 앱 엔트리: 공통 초기화 → 레이아웃별 초기화(HomeLayout/AdminLayout) → PageApplication(라우트 TS).
 */
import { Toast } from "./utils/Toast";
import { Modal } from "./utils/Modal";
import { I18n, t } from "./utils/I18n";
import { SearchInput } from "./components/SearchInput";
import { HomeLayout } from "./app/HomeLayout";
import { AdminLayout } from "./app/AdminLayout";
import { PageApplication } from "./app/PageApplication";
import { controllerRegistry } from "./app/ControllerRegistry";

export class Application {
    boot(): void {
        // i18n 먼저 — Modal 등 다른 모듈이 t() 를 쓰기 전에 #app-i18n 파싱.
        I18n.init();
        this.exposeToastModal();
        this.initNewsFilter();
        SearchInput.initAll();

        if (document.body.classList.contains("admin")) {
            AdminLayout.init();
        } else {
            HomeLayout.init();
        }

        new PageApplication(controllerRegistry).run();
    }

    private exposeToastModal(): void {
        const w = window as unknown as {
            Toast: typeof Toast;
            Modal: typeof Modal;
            I18n: typeof I18n;
            t: typeof t;
        };
        w.Toast = Toast;
        w.Modal = Modal;
        w.I18n = I18n;
        w.t = t;
    }

    /**
     * News 좌측 필터 사이드바 — 정렬·카테고리·태그 라디오 변경 시 즉시 GET 제출.
     * 폼에 page 필드가 없으므로 필터 변경 시 1페이지부터 다시 조회된다(검색은 Enter=폼 기본 submit).
     */
    private initNewsFilter(): void {
        const form = document.querySelector<HTMLFormElement>("form[data-news-filter]");
        if (!form) {
            return;
        }
        form.querySelectorAll<HTMLInputElement>("[data-news-filter-submit]").forEach((input) => {
            input.addEventListener("change", () => {
                if (typeof form.requestSubmit === "function") {
                    form.requestSubmit();
                } else {
                    form.submit();
                }
            });
        });
    }
}
